import React from 'react';
import {DetailsField} from 'components';

const hiddenLabelsForAvk = new Set<string>([
	'tags',
	'phaseIn',
	'phaseOut',
	'dateNewRegistration',
	'dateNewTypes',
	'requirements',
	'vehicleCategories',
	'driveVariants',
	'modelYear',
]);

export const useParagraphDetailsFields = ({
	rows,
	isAvk,
}: {
	rows: DetailsField[][];
	isAvk: boolean;
}): DetailsField[][] => {
	return React.useMemo(() => {
		if (!isAvk) return rows;
		return rows
			.map(row =>
				row.filter(field => !hiddenLabelsForAvk.has(field.key?.trim() ?? '')),
			)
			.filter(row => row.length > 0);
	}, [isAvk, rows]);
};
